<template>
  <div class="card">
    <div class="card-body p-0">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h6>{{ $t('statisticstxt') }}</h6>
        <div v-if="exposure.lastupdate" class="small text-muted d-flex align-items-center">
          {{ exposure.lastupdate }}&nbsp;&nbsp;
        </div>
      </div>

      <div class="card-body">
        <div class="row">
          <div
            class="col-md-6 mb-3"
            v-for="(item, index) in statItems"
            :key="index"
          >
            <div class="d-flex justify-content-between align-items-center label-stat">
              <div class="d-flex align-items-center">
                {{ $t(item.label) }}
                <el-tooltip
                  :content="$t(item.tooltip)"
                  :open-delay="100"
                  placement="top"
                  popper-class="adjust-width"
                >
                  <i class="nc-icon nc-alert-circle-i abit-down ml-1"></i>
                </el-tooltip>
              </div>
              <div
                class="text-right pad-me-right"
                :class="getStatClass(itemValue(item), item.positive, item.key)"
              >
                <span>{{ formatValue(itemValue(item), item.format) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { Tooltip } from 'element-ui';
import Vue from 'vue';

Vue.use(Tooltip);

export default {
  props: {
    exposure: { type: Object, required: true, default: () => ({}) },
  },
  computed: {
    statItems() {
      return [
        {
          label: 'totalReturnstxt',
          tooltip: 'totalReturnsEquitytxt_tt',
          key: 'accumulatedEquityGrowth',
          positive: true,
          format: 'percent'
        },
        {
          label: 'dailyAvgVolatility',
          tooltip: 'dailyAvgVolatility_tt',
          key: 'dailyAvgVolatility',
          format: 'percent'
        },
        {
          label: 'maxDrawdown',
          tooltip: 'maxDrawdown_tt',
          key: 'maxDrawdown',
          positive: false,
          format: 'percent'
        },
        {
          label: 'maxFloating',
          tooltip: 'maxFloating_tt',
          key: 'maxFloating',
          positive: false,
          format: 'percent'
        },
        {
          label: 'totalNumberOfTrades',
          tooltip: 'totalNumberOfTrades_tt',
          key: 'totalTradingOrders',
          format: 'number'
        },
        {
          label: 'monthsSinceInception',
          tooltip: 'monthsSinceInception_tt',
          key: 'monthsOfHistory',
          format: 'number'
        },
      ];
    }
  },
  methods: {
    itemValue({ key }) {
      return Number.isFinite(+key) ? +key : this.exposure[key] || 0;
    },
    formatValue(value, type) {
      switch (type) {
        case 'percent':
          return `${(value * 100).toFixed(2)}%`;
        case 'float':
          return Number(value).toFixed(2);
        default:
          return value;
      }
    },
    getStatClass(value, isPositiveGood = true, key = '') {
      const percentage = value * 100;

      switch (key) {
        case 'totalTradingOrders':
        case 'monthsOfHistory':
          return 'text-secondary label-stat'; // Neutral color

        case 'effectiveDrawdown':
        case 'floating':
          if (percentage > 50) return 'text-danger label-stat'; // Orange
          return 'text-success label-stat'; // Green

        case 'dailyAvgVolatility':
          if (percentage > 5) return 'text-danger label-stat'; // Orange
          return 'text-success label-stat'; // Green

        case 'accumulatedEquityGrowth':
          if (value > 0) return 'text-success label-stat'; // Green
          if (value < 0) return 'text-danger label-stat'; // Orange
          return 'text-secondary label-stat'; // Neutral (zero)

        default:
          const isPositive = value >= 0;
          const isGood = isPositiveGood ? isPositive : !isPositive;
          return isGood ? 'text-success label-stat' : 'text-danger label-stat';
      }
    }
  }
};
</script>

<style scoped>
.label-stat {
  font-weight: 500;
}
.pad-me-right {
  padding-right: 1rem;
}
.abit-down {
  margin-top: 2px;
}
</style>
